import { validateRequiredString } from '../../../common'
import { LocalityAbbreviationDictionary, StreetAbbreviationDictionary } from './commonKladrDictionaries'

export type Code = string

export enum AddressLevel {
  LOCALITY = 'locality',
  STREET = 'street',
  HOUSE = 'house',
}

enum EntityLevelCodeLength {
  MUNICIPAL_ENTITY = 5,
  LOCALITY = 11,
  STREET = 15,
  HOUSE = 15,
}

function getMEPartByCode(code: Code) {
  return code.slice(0, EntityLevelCodeLength.MUNICIPAL_ENTITY)
}

function getLocalityPartByCode(code: Code) {
  return code.slice(0, EntityLevelCodeLength.LOCALITY)
}

function getStreetPartByCode(code: Code) {
  return code.slice(0, EntityLevelCodeLength.STREET)
}

export class MunicipalEntityCode {
  private code: Code
  constructor(code: Code) {
    validateRequiredString('<b0927acc> code', code, {
      pattern: new RegExp(`^[0-9]{${EntityLevelCodeLength.MUNICIPAL_ENTITY}}(0{2})?`),
    })
    this.code = getMEPartByCode(code)
  }
  toString(): Code {
    return this.code
  }
}

export class LocalityCode {
  private code: Code
  constructor(code: Code) {
    validateRequiredString('<5d270a3d> code', code, {
      pattern: new RegExp(`^[0-9]{${EntityLevelCodeLength.LOCALITY}}(0{2})?`),
    })
    this.code = getLocalityPartByCode(code)
  }

  toME(): MunicipalEntityCode {
    return new MunicipalEntityCode(getMEPartByCode(this.code))
  }

  matchesME(code: MunicipalEntityCode): boolean {
    return this.code.startsWith(code.toString())
  }

  toString(): Code {
    return this.code
  }
}

export class StreetCode {
  private code: Code
  constructor(code: Code) {
    validateRequiredString('<c51b5324> code', code, {
      pattern: new RegExp(`^[0-9]{${EntityLevelCodeLength.STREET}}(0{2})?`),
    })
    this.code = getStreetPartByCode(code)
  }
  toLocality(): LocalityCode {
    return new LocalityCode(this.code)
  }
  toME(): MunicipalEntityCode {
    return this.toLocality().toME()
  }
  matchesLocality(code: LocalityCode): boolean {
    return this.code.startsWith(code.toString())
  }
  matchesME(code: MunicipalEntityCode): boolean {
    return this.code.startsWith(code.toString())
  }
  toString(): Code {
    return this.code
  }
}

export class HouseCode {
  private code: Code
  constructor(code: Code) {
    validateRequiredString('<2cd79bf7> code', code, {
      pattern: new RegExp(`^[0-9]{${EntityLevelCodeLength.HOUSE}}([0-9]{4})?`),
    })
    this.code = code.slice(0, EntityLevelCodeLength.HOUSE)
  }
  toLocality(): LocalityCode {
    return new LocalityCode(getLocalityPartByCode(this.code))
  }
  toStreet(): StreetCode {
    return new StreetCode(getStreetPartByCode(this.code))
  }
  toString(): Code {
    return this.code
  }
  matchesLocality(code: LocalityCode): boolean {
    return this.code.startsWith(code.toString())
  }
}

export function beautifyLocalityAbbreviation(v: string): string {
  return LocalityAbbreviationDictionary.get(v) || v
}

export function beautifyStreetAbbreviation(v: string): string {
  return StreetAbbreviationDictionary.get(v) || v
}

export function getMockedSelectedRegions(): Array<string> {
  return ['61']
}
export function getBatchSizeForDbfChunk(): number {
  return 20
}
export function getChunkSizeForFileRead(): number {
  return 20
}
